import { default as _91_91filterIndex_93_93DDnngq0h8NMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/list/[[filterIndex]].vue?macro=true";
import { default as index8YLVbdmzcPMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/themefindroom/index.vue?macro=true";
import { default as indexAfkNa67apqMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/brandfindroom/brandlist/index.vue?macro=true";
import { default as _91_91brandId_93_93vo0vWy2eMdMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/brandfindroom/floorlist/[[brandId]].vue?macro=true";
import { default as indexqM2x6SzvIQMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/findhouse/index.vue?macro=true";
import { default as indexqTsaM3kgLZMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/ranking/index.vue?macro=true";
import { default as _91floorId_93gEYKAqSXK2Meta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/[floorId].vue?macro=true";
import { default as _91floorId_93sWCiXdVY2fMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/mapdetail/[floorId].vue?macro=true";
import { default as indexeSUziguYkAMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/propertydetails/[floorId]/index.vue?macro=true";
import { default as _91floorId_93mjAa6Ve9AnMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/flooralbum/[floorId].vue?macro=true";
import { default as indexlOK8VKQCiqMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/housegroup/[floorId]/index.vue?macro=true";
import { default as _91houseModelId_93jgQ1SO5ebjMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/housegroup/[floorId]/[houseModelId].vue?macro=true";
import { default as indexYuNamDeZQ0Meta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/freelookhouse/index.vue?macro=true";
import { default as detailEYqlgyiBUDMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/freelookhouse/detail.vue?macro=true";
import { default as floorEvaluatingnaGZo19T9JMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/floorEvaluating.vue?macro=true";
import { default as _91floorId_93JgoaihYyQjMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/housePriceAnalysis/[floorId].vue?macro=true";
import { default as _91floorId_938nbqFgV3xYMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/oneprice/[floorId].vue?macro=true";
import { default as _91floorHouseId_933seGLqTDAiMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/houseDetail/[floorHouseId].vue?macro=true";
import { default as _91floorId_93EuFPFbxjUqMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/real-estate-dynamics/[floorId].vue?macro=true";
import { default as healthylj3f4mIz3Meta } from "/workspace/Fccs-PC-Nuxt-V3/pages/health.vue?macro=true";
import { default as indexGcjTw5mCMeMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/index.vue?macro=true";
import { default as indexUeu1Aqf5YNMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/detail/index.vue?macro=true";
import { default as houseTypeAnalysisl9gAR5VizuMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/houseTypeAnalysis.vue?macro=true";
import { default as lifeMecTlxC30EMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/life.vue?macro=true";
import { default as priceAnalysisF2XoyYX3MfMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/priceAnalysis.vue?macro=true";
import { default as schoolKCk4pXiOXLMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/school.vue?macro=true";
import { default as trafficZ16DC6e2U8Meta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/traffic.vue?macro=true";
import { default as indexvhM4B8yYdtMeta } from "/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/example/index.vue?macro=true";
export default [
  {
    name: "_newhouse-list",
    path: "/newhouse/:filterIndex?",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/list/[[filterIndex]].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-shop",
    path: "/shop/:filterIndex?",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/list/[[filterIndex]].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-office",
    path: "/office/:filterIndex?",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/list/[[filterIndex]].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-themefindroom-list",
    path: "/newhouse/themefindroom.html",
    meta: {"layout":"brand-layout"},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/themefindroom/index.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-themefindroom",
    path: "/newhouse/themefindroom_:themeId?.html",
    meta: {"layout":"brand-layout"},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/themefindroom/index.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-brandlist",
    path: "/newhouse/brandfindroom/brandlist.html",
    meta: {"layout":"brand-layout"},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/brandfindroom/brandlist/index.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-brandlist-detail",
    path: "/newhouse/brandfindroom/floorlist/:brandId.html",
    meta: {"layout":"brand-layout"},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/brandfindroom/floorlist/[[brandId]].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-map",
    path: "/newhouse/map/newhouse/",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/findhouse/index.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-ranking-default",
    path: "/newhouse/ranking.html",
    meta: {"layout":"brand-layout"},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/ranking/index.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-ranking",
    path: "/newhouse/ranking_:rankingTypeId.html",
    meta: {"layout":"brand-layout"},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/ranking/index.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-index",
    path: "/newhouse/:floorId(\\d+)/index.html",
    meta: {"layout":"new-house-index-detail","tabActive":0},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-office-detail",
    path: "/office/:floorId(\\d+)/index.html",
    meta: {"layout":"new-house-index-detail","tabActive":0},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-shop-detail",
    path: "/shop/:floorId(\\d+)/index.html",
    meta: {"layout":"new-house-index-detail","tabActive":0},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-mapdetail",
    path: "/newhouse/mapdetail/:floorId(\\d+)/index.html",
    meta: {"layout":"floor-layout","tabActive":7},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/mapdetail/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-brief",
    path: "/newhouse/:floorId(\\d+)/brief.html",
    meta: {"layout":"floor-layout","tabActive":1},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/propertydetails/[floorId]/index.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-photo",
    path: "/newhouse/:floorId/photo.html",
    meta: {"layout":"floor-layout","tabActive":2},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/flooralbum/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-model",
    path: "/newhouse/:floorId(\\d+)/model.html",
    meta: {"layout":"floor-layout","tabActive":3},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/housegroup/[floorId]/index.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-model-detil",
    path: "/newhouse/:floorId(\\d+)/model\\_:houseModelId.html",
    meta: {"layout":"floor-layout","tabActive":3},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/housegroup/[floorId]/[houseModelId].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-group",
    path: "/newhouse/kanfang.html",
    meta: {"layout":"brand-layout","tabActive":3},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/freelookhouse/index.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-group-detail",
    path: "/newhouse/kanfang/:visitId.html",
    meta: {"layout":"brand-layout"},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/freelookhouse/detail.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-evaluate",
    path: "/newhouse/floorEvaluating/:floorId.html",
    meta: {"layout":"floor-layout","tabActive":4},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/floorEvaluating.vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-house-price-analysis",
    path: "/newhouse/:floorId(\\d+)/price.html",
    meta: {"layout":"floor-layout","tabActive":5},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/housePriceAnalysis/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-building",
    path: "/newhouse/oneprice/:floorId.html",
    meta: {"layout":"floor-layout","tabActive":6},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/oneprice/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-houseDetail",
    path: "/newhouse/detail/:floorId/houseDetail/:floorHouseId",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/houseDetail/[floorHouseId].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-news-list",
    path: "/newhouse/:floorId(\\d+)/news.html",
    meta: {"layout":"floor-layout","tabActive":8},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/real-estate-dynamics/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "_newhouse-news",
    path: "/newhouse/:floorId(\\d+)/news_:floorNewsTab.html",
    meta: {"layout":"floor-layout","tabActive":8},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/real-estate-dynamics/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "healthhtml",
    path: "/health.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/health.vue").then(m => m.default || m)
  },
  {
    name: "indexhtml",
    path: "/index.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-brandfindroom-brandlisthtml",
    path: "/newhouse/brandfindroom/brandlist.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/brandfindroom/brandlist/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-brandfindroom-floorlist-brandIdhtml",
    path: "/newhouse/brandfindroom/floorlist/:brandId?.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/brandfindroom/floorlist/[[brandId]].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-floorIdhtml",
    path: "/newhouse/detail/:floorId().html",
    meta: _91floorId_93gEYKAqSXK2Meta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-detailhtml",
    path: "/newhouse/detail/detail.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/detail/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-houseDetail-floorHouseIdhtml",
    path: "/newhouse/detail/houseDetail/:floorHouseId().html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/houseDetail/[floorHouseId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-housegroup-floorId-houseModelIdhtml",
    path: "/newhouse/detail/housegroup/:floorId()/:houseModelId().html",
    meta: _91houseModelId_93jgQ1SO5ebjMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/housegroup/[floorId]/[houseModelId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-housegroup-floorIdhtml",
    path: "/newhouse/detail/housegroup/:floorId().html",
    meta: indexlOK8VKQCiqMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/housegroup/[floorId]/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-propertydetails-floorIdhtml",
    path: "/newhouse/detail/propertydetails/:floorId().html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/propertydetails/[floorId]/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-real-estate-dynamics-floorIdhtml",
    path: "/newhouse/detail/real-estate-dynamics/:floorId().html",
    meta: _91floorId_93EuFPFbxjUqMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/real-estate-dynamics/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-evaluatingModules-houseTypeAnalysishtml",
    path: "/newhouse/evaluatingModules/houseTypeAnalysis.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/houseTypeAnalysis.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-evaluatingModules-lifehtml",
    path: "/newhouse/evaluatingModules/life.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/life.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-evaluatingModules-priceAnalysishtml",
    path: "/newhouse/evaluatingModules/priceAnalysis.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/priceAnalysis.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-evaluatingModules-schoolhtml",
    path: "/newhouse/evaluatingModules/school.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/school.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-evaluatingModules-traffichtml",
    path: "/newhouse/evaluatingModules/traffic.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/traffic.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-examplehtml",
    path: "/newhouse/example.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/example/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-findhousehtml",
    path: "/newhouse/findhouse.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/findhouse/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-flooralbum-floorIdhtml",
    path: "/newhouse/flooralbum/:floorId().html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/flooralbum/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-floorEvaluatinghtml",
    path: "/newhouse/floorEvaluating.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/floorEvaluating.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-freelookhouse-detailhtml",
    path: "/newhouse/freelookhouse/detail.html",
    meta: detailEYqlgyiBUDMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/freelookhouse/detail.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-freelookhousehtml",
    path: "/newhouse/freelookhouse.html",
    meta: indexYuNamDeZQ0Meta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/freelookhouse/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-housePriceAnalysis-floorIdhtml",
    path: "/newhouse/housePriceAnalysis/:floorId().html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/housePriceAnalysis/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-list-filterIndexhtml",
    path: "/newhouse/list/:filterIndex?.html",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/list/[[filterIndex]].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-mapdetail-floorIdhtml",
    path: "/newhouse/mapdetail/:floorId().html",
    meta: _91floorId_93sWCiXdVY2fMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/mapdetail/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-oneprice-floorIdhtml",
    path: "/newhouse/oneprice/:floorId().html",
    meta: _91floorId_938nbqFgV3xYMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/oneprice/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-rankinghtml",
    path: "/newhouse/ranking.html",
    meta: indexqTsaM3kgLZMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/ranking/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-themefindroomhtml",
    path: "/newhouse/themefindroom.html",
    meta: index8YLVbdmzcPMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/themefindroom/index.vue").then(m => m.default || m)
  },
  {
    name: "health",
    path: "/health",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/health.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-brandfindroom-brandlist",
    path: "/newhouse/brandfindroom/brandlist",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/brandfindroom/brandlist/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-brandfindroom-floorlist-brandId",
    path: "/newhouse/brandfindroom/floorlist/:brandId?",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/brandfindroom/floorlist/[[brandId]].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-floorId",
    path: "/newhouse/detail/:floorId()",
    meta: _91floorId_93gEYKAqSXK2Meta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-detail",
    path: "/newhouse/detail/detail",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/detail/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-houseDetail-floorHouseId",
    path: "/newhouse/detail/houseDetail/:floorHouseId()",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/houseDetail/[floorHouseId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-housegroup-floorId-houseModelId",
    path: "/newhouse/detail/housegroup/:floorId()/:houseModelId()",
    meta: _91houseModelId_93jgQ1SO5ebjMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/housegroup/[floorId]/[houseModelId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-housegroup-floorId",
    path: "/newhouse/detail/housegroup/:floorId()",
    meta: indexlOK8VKQCiqMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/housegroup/[floorId]/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-propertydetails-floorId",
    path: "/newhouse/detail/propertydetails/:floorId()",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/propertydetails/[floorId]/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-detail-real-estate-dynamics-floorId",
    path: "/newhouse/detail/real-estate-dynamics/:floorId()",
    meta: _91floorId_93EuFPFbxjUqMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/detail/real-estate-dynamics/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-evaluatingModules-houseTypeAnalysis",
    path: "/newhouse/evaluatingModules/houseTypeAnalysis",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/houseTypeAnalysis.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-evaluatingModules-life",
    path: "/newhouse/evaluatingModules/life",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/life.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-evaluatingModules-priceAnalysis",
    path: "/newhouse/evaluatingModules/priceAnalysis",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/priceAnalysis.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-evaluatingModules-school",
    path: "/newhouse/evaluatingModules/school",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/school.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-evaluatingModules-traffic",
    path: "/newhouse/evaluatingModules/traffic",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/evaluatingModules/traffic.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-example",
    path: "/newhouse/example",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/example/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-findhouse",
    path: "/newhouse/findhouse",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/findhouse/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-flooralbum-floorId",
    path: "/newhouse/flooralbum/:floorId()",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/flooralbum/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-floorEvaluating",
    path: "/newhouse/floorEvaluating",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/floorEvaluating.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-freelookhouse-detail",
    path: "/newhouse/freelookhouse/detail",
    meta: detailEYqlgyiBUDMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/freelookhouse/detail.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-freelookhouse",
    path: "/newhouse/freelookhouse",
    meta: indexYuNamDeZQ0Meta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/freelookhouse/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-housePriceAnalysis-floorId",
    path: "/newhouse/housePriceAnalysis/:floorId()",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/housePriceAnalysis/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-list-filterIndex",
    path: "/newhouse/list/:filterIndex?",
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/list/[[filterIndex]].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-mapdetail-floorId",
    path: "/newhouse/mapdetail/:floorId()",
    meta: _91floorId_93sWCiXdVY2fMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/mapdetail/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-oneprice-floorId",
    path: "/newhouse/oneprice/:floorId()",
    meta: _91floorId_938nbqFgV3xYMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/oneprice/[floorId].vue").then(m => m.default || m)
  },
  {
    name: "newhouse-ranking",
    path: "/newhouse/ranking",
    meta: indexqTsaM3kgLZMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/ranking/index.vue").then(m => m.default || m)
  },
  {
    name: "newhouse-themefindroom",
    path: "/newhouse/themefindroom",
    meta: index8YLVbdmzcPMeta || {},
    component: () => import("/workspace/Fccs-PC-Nuxt-V3/pages/newhouse/themefindroom/index.vue").then(m => m.default || m)
  }
]